import { EpimsBaseEntityDto } from './epim-base.dto';

export class EncroacherDto extends EpimsBaseEntityDto {
  // id: string;
  EncroacherName: string;
  EncroachedWith: string;
  EncroacherCost: number;
  RemovalCost: number;
  EncroachmentStatusId: string;
  Reasons: string;
  EncroacherContact: string;
  Images: string;
  PipelineEncroachmentId: string;
}
